import Image from "next/image";

interface SteamLogoProps {
    alt?: string;
    className?: string;
    width?: number;
    height?: number;
}

export function SteamLogo({
    alt = "",
    className,
    width = 72,
    height = 18,
}: SteamLogoProps) {
    return (
        <Image
            src="/brands/steam-logo-black.webp"
            alt={alt}
            width={width}
            height={height}
            className={className}
        />
    );
}
